import Pattern from "@assets/PNG/Pattern.png";
// import Central from "@assets/SVG/Central.svg";
import Dedicated from "@assets/SVG/Dedicted.svg";
import { OnBoarding } from "@components/index";
import { Col, Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface CardProps {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
  checked: boolean;
  backgroundColor: string;
  borderColor: string;
  iconBackgroundColor: string;
}

const Card = ({
  icon,
  title,
  description,
  onClick,
  checked,
  backgroundColor,
  borderColor,
  iconBackgroundColor,
}: CardProps) => {
  return (
    <div
      onClick={onClick}
      className={`relative cursor-pointer border-2 rounded-2xl border-${borderColor} bg-${backgroundColor} px-5 py-4 mb-4`}
    >
      <input
        type="radio"
        checked={checked}
        className="absolute top-5 right-6 w-[22px] h-[22px] accent-primary"
      />
      <div className={`h-10 w-10 p-2 bg-${iconBackgroundColor} rounded-lg mb-3`}>
        <img
          src={icon}
          alt={title}
        />
      </div>
      <h4 className="text-purple text-lg font-semibold mb-1">{title}</h4>
      <p className="text-sm font-normal text-neutral-1">{description}</p>

      <img
        src={Pattern}
        alt="Pattern"
        className="absolute inset-0"
      />
    </div>
  );
};

export const CMS = () => {
  const [selectedCMS, setSelectedCMS] = useState("");

  const navigate = useNavigate();

  return (
    <OnBoarding>
      <Row style={{ justifyContent: "center" }}>
        <Col span={18}>
          <h2 className="text-xl font-bold leading-6 text-purple mt-10">Welcome to</h2>
          <h3 className="text-lg leading-6 font-semibold mb-3 text-pink">Content Management System</h3>

          <p className="text-sm font-normal text-neutral-1 mb-6">
            Let&apos;s get started! Select the type of CMS to begin
          </p>

          <Col
            span={27}
            className="mb-8"
          >
            {/* <Card
              icon={Central}
              title="Centralized CMS"
              description="A centralized CMS manages digital content from a single location, enabling collaboration, consistency, and efficient organization."
              checked={selectedCMS === "centralized"}
              onClick={() => setSelectedCMS("centralized")}
              backgroundColor="secondary-100"
              iconBackgroundColor="secondary-200"
              borderColor="secondary-300"
            /> */}
            <Card
              icon={Dedicated}
              title="Dedicated CMS"
              description="A dedicated CMS simplifies the process of modifying or updating content within a specific project or product."
              checked={selectedCMS === "dedicated"}
              onClick={() => setSelectedCMS("dedicated")}
              backgroundColor="primary-100"
              iconBackgroundColor="primary-200"
              borderColor="primary-300"
            />
          </Col>

          <button
            className="bg-primary text-white rounded-lg w-full text-sm py-3 px-6 border-[0.5px] disabled:cursor-not-allowed border-primary-100"
            disabled={!selectedCMS}
            onClick={() => {
              if (selectedCMS === "centralized") {
                localStorage.setItem("currentModule", JSON.stringify("CENTRALIZED"));
                navigate(`/centralized/centralizedBanner`, { replace: true });
              } else {
                navigate(`/auth/${selectedCMS}/modules`, { replace: true });
              }
            }}
          >
            Continue
          </button>
        </Col>
        <p className="text-xs font-thin mt-10">
          © 2020-2024 CMS (Content Management System)- CMS co. , all rights reserved.
        </p>
      </Row>
    </OnBoarding>
  );
};
